"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignMedicalAssistantOfficeApiParamsSchema = exports.updateMedicalAssistantApiPayloadSchema = void 0;
const zod_1 = require("zod");
const address_schema_1 = require("../global/address.schema");
const social_security_number_schema_1 = require("../global/social-security-number.schema");
const enums_1 = require("./enums");
exports.updateMedicalAssistantApiPayloadSchema = zod_1.z.object({
    firstname: zod_1.z.string().optional(),
    lastname: zod_1.z.string().optional(),
    phone: zod_1.z.string().nullable().optional(),
    contractType: enums_1.contractTypeSchema.optional(),
    weeklyHours: zod_1.z.number().optional(),
    hireDate: zod_1.z.string().optional(),
    dateOfBirth: zod_1.z.string().nullable().optional(),
    birthPlace: zod_1.z.string().nullable().optional(),
    nationality: zod_1.z.string().nullable().optional(),
    socialSecurityNumber: social_security_number_schema_1.socialSecurityNumberSchema.nullable().optional(),
    // Payroll flags: accepted on the admin route only. The self route shares
    // this payload type but deliberately drops them — see assistants.controller.
    hasSupplementaryHealthInsurance: zod_1.z.boolean().optional(),
    hasTransportAllowance: zod_1.z.boolean().optional(),
    address: address_schema_1.assistantAddressSchema.nullable().optional(),
});
exports.assignMedicalAssistantOfficeApiParamsSchema = zod_1.z.object({
    id: zod_1.z.string(),
    officeId: zod_1.z.string(),
});
